import { User } from "@/CodegenTypes";

type TtCompanyLevelUser = Pick<
  User,
  "ttD1CompanyPl" | "ttD2CompanyPl" | "ttD3CompanyPl" | "ttD4CompanyPl"
>;

export const canSeeTtCompanyLevel = (user?: TtCompanyLevelUser | null) => {
  return (
    (user?.ttD1CompanyPl || 0) > 0 &&
    (user?.ttD2CompanyPl || 0) > 0 &&
    (user?.ttD3CompanyPl || 0) > 0 &&
    (user?.ttD4CompanyPl || 0) > 0
  );
};
